import "./stylesheets/main.css";
import React, {useEffect, useState} from "react";
import {BrowserRouter as Router, Link, Route, Routes, useNavigate, useSearchParams} from "react-router-dom";
import CreatePaidAccount from "./components/forms/CreatePaidAccount/CreatePaidAccount.js";
import "@fontsource/roboto";

import {Provider, useDispatch, useSelector} from "react-redux";
import {applyMiddleware, createStore} from "redux";
import {thunk} from "redux-thunk";
import Reducers from "./redux/Reducers.js";
import {SnackbarProvider} from "notistack";
import {Banner} from "./components/elements/Banner.js";
import {Product, Customer, Subscription, Item} from "./models/stripe.js";
import {
    fetchOrganizations,
    fetchOrganizationUserGroupsForUser,
    fetchOrganizationUsers,
    logout,
} from "./redux/user/Action.js";
import {
    fetchMetrcAccounts,
    fetchLeaflogixAccounts,
    setMetrcAccounts,
    setDutchieAccounts, selectIntegration
} from "./redux/models/integrations/Action";
import Notifier from "./components/notifications/Notifier.js";
import ForgotPassword from "./views/ForgotPassword.js";
import ResetPassword from "./views/ResetPassword.js";
import MainMenu from "./components/main-menu";
import IntegrationSelector from "./components/integration-selector";
import OrganizationList from "./views/organizations/List.js";
import OrganizationDetail from "./views/organizations/Detail.js";
import IntegrationSetup from "./views/integrations/Setup.js";
import MetrcIntegrationList from "./views/integrations/metrc/List.js";
import MetrcIntegrationDetail from "./views/integrations/metrc/Detail.js";
import MetrcIntegrationSetup from "./views/integrations/metrc/Setup.js";
import Analytics from "./views/Analytics/Analytics.js";
import AlpineIQIntegrationList from "./views/integrations/alpineiq/List.js";
import AlpineIQIntegrationDetail from "./views/integrations/alpineiq/Detail.js";
import AlpineIQIntegrationSetup from "./views/integrations/alpineiq/Setup.js";
import LeaflogixIntegrationDetail from "./views/integrations/dutchie/Detail.js";
import LeaflogixIntegrationSetup from "./views/integrations/dutchie/Setup.js";
import LeaflogixIntegrationList from "./views/integrations/dutchie/List.js";
import IdScanIntegrationDetail from "./views/integrations/idscan/Detail.js";
import IdScanIntegrationSetup from "./views/integrations/idscan/Setup.js";
import IdScanIntegrationList from "./views/integrations/idscan/List.js";
import ProductDetail from "./views/Analytics/verticals/retail/tabs/ProductDetail/ProductDetail";
import MyAccount from "./views/MyAccount.js";
import Home from "./views/home/Home.js";
import {getCookie, hasPendingInvitations, isNullOrUndefinedOrEmpty} from "./utils.js";
import {showInformationalPopup, showPopup} from "./redux/notifications/Action.js";
import {Popup} from "./components/notifications/Popup.js";
import {selectOrganization} from "./redux/models/organizations/Action.js";
import {isEmpty, Client, removeCookie} from "weed-js";
import {
    ROUTES_ANALYTICS,
    ROUTES_ANALYTICS_DETAIL_WHOLESALE,
    ROUTES_ANALYTICS_DETAIL_RETAIL,
    RETAIL,
    HOME,
    WHOLESALE,
    CULTIVATION,
    MANUFACTURING,
    RETAIL_REPORTS,
    RETAIL_EMPLOYEES,
    RETAIL_PROCUREMENT,
    RETAIL_PROMOTIONS,
    RETAIL_RISK,
    RETAIL_VENDORS,
    ROUTES_ANALYTICS_DETAIL_CULTIVATION,
    ROUTES_ANALYTICS_DETAIL_MANUFACTURING,
    ROUTES_ANALYTICS_DETAIL_RETAIL_COST_AND_MARGIN,
    ROUTES_ANALYTICS_DETAIL_RETAIL_EMPLOYEES,
    ROUTES_ANALYTICS_DETAIL_RETAIL_PROCUREMENT,
    ROUTES_ANALYTICS_DETAIL_RETAIL_PROMOTIONS,
    ROUTES_ANALYTICS_DETAIL_RETAIL_RISK,
    ROUTES_ANALYTICS_DETAIL_RETAIL_VENDORS,
    ROUTES_ANALYTICS_PRODUCT_DETAIL,
} from "./views/Analytics/constants.js";

import {
    AUTHENTICATION,
    BACKFILLS,
    FACILITIES,
    ROLES,
    ROUTES_FORGOT_PASSWORD,
    ROUTES_HOME,
    ROUTES_INTEGRATIONS,
    ROUTES_INTEGRATIONS_ALPINEIQ_DETAIL,
    ROUTES_INTEGRATIONS_ALPINEIQ_LIST,
    ROUTES_INTEGRATIONS_ALPINEIQ_SETUP,
    ROUTES_INTEGRATIONS_IDSCAN_DETAIL,
    ROUTES_INTEGRATIONS_IDSCAN_LIST,
    ROUTES_INTEGRATIONS_IDSCAN_SETUP,
    ROUTES_INTEGRATIONS_LEAFLOGIX_DETAIL,
    ROUTES_INTEGRATIONS_LEAFLOGIX_DETAIL_AUTHENTICATION,
    ROUTES_INTEGRATIONS_LEAFLOGIX_DETAIL_BACKFILLS,
    ROUTES_INTEGRATIONS_LEAFLOGIX_LIST,
    ROUTES_INTEGRATIONS_LEAFLOGIX_SETUP,
    ROUTES_INTEGRATIONS_METRC_DETAIL,
    ROUTES_INTEGRATIONS_METRC_DETAIL_AUTHENTICATION,
    ROUTES_INTEGRATIONS_METRC_DETAIL_BACKFILLS,
    ROUTES_INTEGRATIONS_METRC_DETAIL_FACILITIES,
    ROUTES_INTEGRATIONS_METRC_LIST,
    ROUTES_INTEGRATIONS_METRC_SETUP,
    ROUTES_MY_ACCOUNT,
    ROUTES_ORGANIZATIONS_DETAIL,
    ROUTES_ORGANIZATIONS_DETAIL_SUBSCRIPTIONS,
    ROUTES_ORGANIZATIONS_DETAIL_USERS_AND_ROLES,
    ROUTES_ORGANIZATIONS_LIST,
    ROUTES_RESET_PASSWORD, SUBSCRIPTIONS,
} from "./utils/Constants.js";
import {
    SSO_ACTIONS,
    SSO_DO_LOGOUT,
    SSO_LINKBACK,
    SSO_RESET_PASSWORD,
    SSO_SUBSCRIPTION_CANCELED, SSO_SUBSCRIPTION_CHECKOUT_CANCELED, SSO_SUBSCRIPTION_ERROR,
    SSO_VERIFY, SSO_WELCOME_TOUR
} from "./redux/constants.js";
import {fetchUserProfile, fetchCurrentUser, userLoggedIn} from "./redux/user/Action.js";
import Loading from "./components/elements/Loading.js";
import {MetrcAccount} from "./models/metrc";
import {DutchieAccount} from "./models/dutchie";
import {Facility as MetrcFacility} from "./models/sso";
import {ALPINEIQ, DUTCHIE, METRC} from "./constants";

export function configureStore(InitialState) {
    const Store = createStore(
        Reducers,
        InitialState,
        applyMiddleware(thunk)
    );
    return Store;
}


const Main = () => {
    const navigate = useNavigate();

    const loggedInUser = useSelector(state => state.userReducer.loggedInUser.user);
    const setLoggedInUser = (user) => userLoggedIn({user: user});
    const organizationUsers = useSelector(state => state.userReducer.loggedInUser.organizationUsers);
    const userProfile = useSelector(state => state.userReducer.loggedInUser.profile);
    const setUserProfile = (profile) => userLoggedIn({profile: profile});
    const [isLoading, setIsLoading] = useState(true); // useSelector(state => state.userReducer.loading);
    const organizations = useSelector(state => state.userReducer.loggedInUser.organizations);
    const selectedOrganization = useSelector(state => state.organizationReducer.selectedOrganization);
    const selectedIntegration = useSelector(state => state.integrationReducer.selectedIntegration);
    const selectedIntegrationAccounts = useSelector(state => state.integrationReducer.accounts.selectedAccounts);
    const metrcAccounts = useSelector(state => state.integrationReducer.accounts.metrc);
    const dutchieAccounts = useSelector(state => state.integrationReducer.accounts.dutchie);
    const [subscriptions, setSubscriptions] = useState(undefined);
    const [subscriptionItems, setSubscriptionItems] = useState([]);
    const [subscriptionProducts, setSubscriptionProducts] = useState([]);
    const [closeCreateAccountWorkflow, setCloseCreateAccountWorkflow] = useState(false);
    const [hasActiveSubscription, setHasActiveSubscription] = useState(false);
    const [currentDutchieStores, setCurrentDutchieStores] = useState(0);
    const [currentMetrcStores, setCurrentMetrcStores] = useState(0);
    const maxDutchieStores = subscriptions?.reduce((acc, sub) => {
        return acc + sub.getMaximumDutchieStores() || 0
    }, 0);
    const maxMetrcStores = subscriptions?.reduce((acc, sub) => acc + sub.getMaximumMetrcStores(), 0) || 0;

    const dispatch = useDispatch();
    const [params, setParams] = useSearchParams();
    const [actionId, setActionId] = useState(params.get("a"));
    const [errorMessage, setErrorMessage] = useState(params.get("m"));
    const action = SSO_ACTIONS[actionId];
    const organizationId = isNullOrUndefinedOrEmpty(getCookie("organizationId")) ? null : parseInt(getCookie("organizationId"));
    const ssoCookie = getCookie("sso");
    const [showCreateAccountWorkflow, setShowCreateAccountWorkflow] = useState(false);
    const integrationAbortControllerRef = React.useRef(new AbortController());
    const [banner, setBanner] = useState(null);
    const client = new Client();

    const setOrganizations = (newOrganizations) => {
        dispatch(userLoggedIn({
            user: loggedInUser,
            organizations: newOrganizations,
            profile: userProfile,
        }));
    };

    const createPaidAccountJSX = isLoading ? null : <CreatePaidAccount
        key={"create-paid-account"}
        loggedInUser={loggedInUser}
        userProfile={userProfile}
        hideModal={closeCreateAccountWorkflow || !showCreateAccountWorkflow}
        setHideModal={(v) => {
            setCloseCreateAccountWorkflow(v);
            setShowCreateAccountWorkflow(!v)
        }}
        setLoggedInUser={setLoggedInUser}
        setUserProfile={setUserProfile}
        selectedOrganization={selectedOrganization}
        selectedIntegration={selectedIntegration}
        selectedIntegrationAccounts={selectedIntegrationAccounts}
        setOrganizations={setOrganizations}
        organizations={organizations}
    />

    useEffect(() => {
        const integrationCookie = getCookie("integration");
        if (integrationCookie === DUTCHIE || integrationCookie === METRC || integrationCookie === ALPINEIQ) {
            dispatch(selectIntegration(integrationCookie));
        } else if (!isEmpty(integrationCookie)) {
            removeCookie("integration");
        }
    }, []);

    useEffect(() => {
        // if (showCreateAccountWorkflow && !closeCreateAccountWorkflow) {
        //     return;
        // }
        const abortController = new AbortController();
        if (isEmpty(ssoCookie)) {
            setIsLoading(() => false);
            return;
        }
        if (isEmpty(loggedInUser) || isEmpty(userProfile)) {
            dispatch(fetchCurrentUser(abortController)).then((currentUser) => {
                if (!currentUser.id) {
                    console.error("Fetched an empty user!")
                    setIsLoading(false);
                    return;
                }
                Promise.all([
                    dispatch(fetchUserProfile(currentUser, abortController)),
                    dispatch(fetchOrganizationUserGroupsForUser(currentUser, abortController)),
                    dispatch(fetchOrganizationUsers(null, currentUser.id, abortController)),
                    dispatch(fetchOrganizations(null, abortController))
                ]).then(response => {
                    const [fetchedUserProfile, fetchedOrganizationUserGroups, fetchedOrganizationUsers, fetchedOrganizations] = response;
                    if (loggedInUser?.id !== currentUser?.id || fetchedUserProfile?.id !== userProfile?.id) {
                        dispatch(userLoggedIn({
                            user: currentUser,
                            organizationUsers: fetchedOrganizationUsers,
                            organizations: fetchedOrganizations,
                            organizationUserGroups: fetchedOrganizationUserGroups,
                            profile: fetchedUserProfile,
                        }))
                    }
                    setIsLoading(false);
                });
            }).catch((error) => {
                console.error("Got an error getting the current user in App.js", error)
                setIsLoading(() => false);
            });
        } else {
            console.warn("Somehow we already have the logged in user/user profile. Strange!")
            setIsLoading(() => false);
        }

        return () => {
            abortController.abort();
        };
    }, [loggedInUser]);


    useEffect(() => {
        if (params.has("m")) {
            params.delete("m");
            params.delete("a");
            setParams(params);
            dispatch(showPopup(action, errorMessage));
        } else if (params.has("a")) {
            params.delete("a");
            setParams(params);
            if (action === SSO_RESET_PASSWORD) {
                navigate(ROUTES_RESET_PASSWORD);
            } else if (action === SSO_DO_LOGOUT) {
                dispatch(logout()).then(response => {
                    return dispatch(showPopup(action));
                }).catch(err => {
                    console.error(err);
                });
            } else if (action === SSO_VERIFY || action === SSO_LINKBACK) {
                setShowCreateAccountWorkflow(true);
                setCloseCreateAccountWorkflow(false);
            } else {
                dispatch(showPopup(action));
            }
        }
    }, [loggedInUser]);

    useEffect(() => {
        if (!loggedInUser?.id || isNullOrUndefinedOrEmpty(organizations)) {
            return;
        }
        if (selectedOrganization?.id === parseInt(organizationId)) {
            return;
        }
        if (organizationId) {
            const org = organizations.find(o => o.id === parseInt(organizationId));
            if (org) {
                dispatch(selectOrganization(org));
            }
        } else if (organizations.length !== 0) {
            dispatch(selectOrganization(organizations[0]));
        }
    }, [organizationId, organizations, loggedInUser]);


    useEffect(() => {
        if (isNullOrUndefinedOrEmpty(organizationUsers)) {
            return;
        }
        if (hasPendingInvitations(organizationUsers)) {
            dispatch(showInformationalPopup("Pending Invitations", <p>
                    You have pending invitations to existing organizations. Click &quot;OK&quot; to accept or delete them.
            </p>,
            () => {
                navigate(ROUTES_ORGANIZATIONS_LIST);
            },
            () => {

            },
            "acknowledge-pending-invitations"
            ));
        }
    }, [loggedInUser, organizationUsers]);


    useEffect(() => {
        if (loggedInUser?.id && isEmpty(organizations) && !isLoading) {
            setShowCreateAccountWorkflow(true);
            return;
        }
        if (isEmpty(selectedOrganization) || !selectedOrganization?.id) {
            return;
        }


        const abortController = new AbortController();

        Promise.all([
            Subscription.fetch({client, params: {organization_id: selectedOrganization?.id || null}, abortController}),
            Product.fetch({client, params: {}, abortController})
        ]).then(([fetchedSubscriptions, fetchedSubscriptionProducts]) => {
            const subscriptionIds = fetchedSubscriptions?.map(s => s.id) || [];
            if (isEmpty(subscriptionIds)) {
                setSubscriptions([]);
                setSubscriptionItems([]);
                setSubscriptionProducts(fetchedSubscriptionProducts || []);
                setShowCreateAccountWorkflow(true);
                return;
            }
            Item.fetch({
                client,
                params: {subscription_id__in: subscriptionIds.join(",")},
                abortController
            }).then((fetchedSubscriptionItems) => {
                let showWorkflow = false;
                if (fetchedSubscriptionItems?.length > 0) {
                    setSubscriptionItems(fetchedSubscriptionItems || []);
                } else {
                    setSubscriptionItems([]);
                    showWorkflow = true;
                }
                if (fetchedSubscriptions?.length > 0) {
                    setSubscriptions(fetchedSubscriptions);
                } else {
                    setSubscriptions([]);
                    showWorkflow = true;
                }
                if (fetchedSubscriptionProducts?.length > 0) {
                    setSubscriptionProducts(fetchedSubscriptionProducts);
                } else {
                    setSubscriptionProducts([]);
                }
                setShowCreateAccountWorkflow(showWorkflow);
            });
        });

        return () => {
            abortController.abort();
        }
    }, [loggedInUser, selectedOrganization]);

    useEffect(() => {
        for (let i = 0; i < subscriptions?.length; i++) {
            const subscription = subscriptions[i];
            if (subscription.getMaximumDutchieStores() > 0 || subscription.getMaximumMetrcStores() > 0) {
                setHasActiveSubscription(true);
                return;
            }
        }
    }, [subscriptions, subscriptionItems, subscriptionProducts]);

    useEffect(() => {
        if (!isEmpty(metrcAccounts) || !isEmpty(dutchieAccounts) || isEmpty(selectedOrganization)) {
            return;
        }

        integrationAbortControllerRef.current?.abort();
        integrationAbortControllerRef.current = new AbortController();

        Promise.all([
            dispatch(fetchMetrcAccounts(
                {
                    organization_id: selectedOrganization?.id || null,
                },
                integrationAbortControllerRef?.current
            )),
            dispatch(fetchLeaflogixAccounts(
                {
                    organization_id: selectedOrganization?.id || null,
                },
                integrationAbortControllerRef?.current
            )),

        ]).then(([fetchedMetrcAccounts, fetchedDutchieAccounts]) => {
            fetchedMetrcAccounts.map(acct => MetrcAccount.byId.get(acct.id) ? null : new MetrcAccount(acct));
            fetchedDutchieAccounts.map(acct => DutchieAccount.byId.get(acct.id) ? null : new DutchieAccount(acct));
            setMetrcAccounts(fetchedMetrcAccounts);
            setDutchieAccounts(fetchedDutchieAccounts);
        });

        return () => {
            integrationAbortControllerRef.current?.abort();
        }
    }, [loggedInUser, selectedOrganization]);

    useEffect(() => {
        if (!selectedOrganization?.id) {
            return;
        }

        const abortController = new AbortController();

        Promise.all([
            MetrcFacility.fetch({
                client,
                params: {limit: 10000, organization_id: selectedOrganization?.id},
                abortController,
            }),
            DutchieAccount.fetch({
                client,
                params: {limit: 10000, organization_id: selectedOrganization?.id},
                abortController,
            })
        ]).then(([facilities, accounts]) => {
            console.log("Setting metrc/dutchie facilities");
            setCurrentMetrcStores(facilities.length);
            setCurrentDutchieStores(accounts.length);
        }).catch(err => {
            console.error("Error fetching Metrc facilities or Dutchie accounts", err);
        });

        return () => {
            return abortController.abort();
        }

    }, [selectedOrganization, subscriptions, metrcAccounts, dutchieAccounts]);

    useEffect(() => {
        const hasDutchieSubscription = subscriptions?.some(s => s.getMaximumDutchieStores() > 0);
        const hasMetrcSubscription = subscriptions?.some(s => s.getMaximumMetrcStores() > 0);
        let bannerMessage = [];
        const link = <Link
            to={ROUTES_ORGANIZATIONS_DETAIL_SUBSCRIPTIONS.replace(":id", selectedOrganization?.id)}>here</Link>

        if (hasDutchieSubscription && currentDutchieStores > maxDutchieStores) {
            bannerMessage.push(<p>
                You have reached your maximum number of Dutchie stores ({currentDutchieStores}/{maxDutchieStores}). To
                add more, please update your subscription {link}.
            </p>);
        }
        // TODO: Add a filter for active/inactive organizations, and a link to deactivate organizations.
        if (hasMetrcSubscription && currentMetrcStores > maxMetrcStores) {
            bannerMessage.push(<p>
                You have reached your maximum number of Metrc stores ({currentMetrcStores}/{maxMetrcStores}). To add
                more, please update your subscription {link}.
            </p>);
        }

        setBanner(bannerMessage.length > 0 ? <Banner variant="warning">
            <h4>Maximum Stores Exceeded</h4>
            {bannerMessage.map((msg, idx) => {
                return <p key={`banner-${idx}`}>{msg}</p>
            })}
        </Banner> : null);
    }, [
        currentDutchieStores,
        currentMetrcStores,
        maxDutchieStores,
        maxMetrcStores,
        selectedOrganization,
        subscriptions
    ]);

    const analyticsElement = <Analytics
        key={ROUTES_ANALYTICS}
        subscriptions={subscriptions}
        subscriptionItems={subscriptionItems}
        subscriptionProducts={subscriptionProducts}
    />

    const loggedOutRoutes = <>
        <Route path={ROUTES_HOME} element={<Home openCreateAccount={() => {
            setShowCreateAccountWorkflow(true);
            setCloseCreateAccountWorkflow(false);
        }}/>}/>
        <Route path={ROUTES_FORGOT_PASSWORD} element={<ForgotPassword/>}/>
        <Route path={ROUTES_RESET_PASSWORD} element={<ResetPassword/>}/>
    </>

    const loggedInRoutes = <>
        <Route path={ROUTES_MY_ACCOUNT}
            element={<MyAccount subscriptions={subscriptions} subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}
            />}/>
        <Route path={ROUTES_RESET_PASSWORD}
            element={<ResetPassword/>}/>
    </>

    const organizationRoutes = <>
        <Route path={ROUTES_ORGANIZATIONS_LIST} element={<OrganizationList/>}/>
        <Route path={ROUTES_ORGANIZATIONS_DETAIL}
            element={<OrganizationDetail subscriptions={subscriptions} subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}
                metrcAccounts={metrcAccounts}
                dutchieAccounts={dutchieAccounts}
                setSubscriptions={setSubscriptions}
                setSubscriptionItems={setSubscriptionItems}
                setShowCreateAccountWorkflow={setShowCreateAccountWorkflow}
                setCloseCreateAccountWorkflow={setCloseCreateAccountWorkflow}
            />}/>
        <Route path={ROUTES_ORGANIZATIONS_DETAIL_USERS_AND_ROLES}
            element={<OrganizationDetail tab={ROLES} subscriptions={subscriptions}
                metrcAccounts={metrcAccounts}
                dutchieAccounts={dutchieAccounts}
                subscriptionItems={subscriptionItems}
                setSubscriptions={setSubscriptions}
                setSubscriptionItems={setSubscriptionItems}
                setShowCreateAccountWorkflow={setShowCreateAccountWorkflow}
                setCloseCreateAccountWorkflow={setCloseCreateAccountWorkflow}
                subscriptionProducts={subscriptionProducts}/>}/>

        <Route path={ROUTES_ORGANIZATIONS_DETAIL_SUBSCRIPTIONS}
            element={<OrganizationDetail tab={SUBSCRIPTIONS} subscriptions={subscriptions}
                metrcAccounts={metrcAccounts}
                dutchieAccounts={dutchieAccounts}
                subscriptionItems={subscriptionItems}
                setSubscriptions={setSubscriptions}
                setSubscriptionItems={setSubscriptionItems}
                setShowCreateAccountWorkflow={setShowCreateAccountWorkflow}
                setCloseCreateAccountWorkflow={setCloseCreateAccountWorkflow}
                subscriptionProducts={subscriptionProducts}/>}/>
    </>

    const integrationRoutes = <>
        {/* Leaflogix */}
        <Route path={ROUTES_INTEGRATIONS_LEAFLOGIX_SETUP}
            element={<LeaflogixIntegrationSetup
                subscriptions={subscriptions} subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}
            />}/>
        <Route path={ROUTES_INTEGRATIONS_LEAFLOGIX_LIST}
            element={<LeaflogixIntegrationList
                subscriptions={subscriptions} subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}
            />}/>
        <Route path={ROUTES_INTEGRATIONS_LEAFLOGIX_DETAIL}
            element={<LeaflogixIntegrationDetail
                subscriptions={subscriptions} subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}
                selectedOrganization={selectedOrganization}/>}/>
        <Route path={ROUTES_INTEGRATIONS_LEAFLOGIX_DETAIL_BACKFILLS}
            element={<LeaflogixIntegrationDetail
                subscriptions={subscriptions} subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}
                selectedOrganization={selectedOrganization} tab={BACKFILLS}/>}/>
        <Route path={ROUTES_INTEGRATIONS_LEAFLOGIX_DETAIL_AUTHENTICATION}
            element={<LeaflogixIntegrationDetail
                subscriptions={subscriptions} subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}
                selectedOrganization={selectedOrganization} tab={AUTHENTICATION}/>}/>

        {/* Metrc */}
        <Route path={ROUTES_INTEGRATIONS_METRC_SETUP}
            element={<MetrcIntegrationSetup
                subscriptions={subscriptions} subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}/>}/>
        <Route path={ROUTES_INTEGRATIONS_METRC_LIST}
            element={<MetrcIntegrationList
                subscriptions={subscriptions} subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}
            />}/>
        <Route path={ROUTES_INTEGRATIONS_METRC_DETAIL}
            element={<MetrcIntegrationDetail
                subscriptions={subscriptions} subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}
                selectedOrganization={selectedOrganization}/>}/>
        <Route path={ROUTES_INTEGRATIONS_METRC_DETAIL_BACKFILLS}
            element={<MetrcIntegrationDetail
                subscriptions={subscriptions} subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}
                selectedOrganization={selectedOrganization} tab={BACKFILLS}/>}/>
        <Route path={ROUTES_INTEGRATIONS_METRC_DETAIL_AUTHENTICATION}
            element={<MetrcIntegrationDetail
                subscriptions={subscriptions} subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}
                selectedOrganization={selectedOrganization} tab={AUTHENTICATION}/>}/>
        <Route path={ROUTES_INTEGRATIONS_METRC_DETAIL_FACILITIES}
            element={<MetrcIntegrationDetail
                subscriptions={subscriptions} subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}
                selectedOrganization={selectedOrganization} tab={FACILITIES}/>}/>

        {/* Alpine IQ */}
        <Route path={ROUTES_INTEGRATIONS_ALPINEIQ_SETUP}
            element={<AlpineIQIntegrationSetup/>}/>
        <Route path={ROUTES_INTEGRATIONS_ALPINEIQ_LIST}
            element={<AlpineIQIntegrationList/>}/>
        <Route path={ROUTES_INTEGRATIONS_ALPINEIQ_DETAIL}
            element={<AlpineIQIntegrationDetail/>}/>

        {/* IdScan */}
        <Route path={ROUTES_INTEGRATIONS_IDSCAN_SETUP}
            element={<IdScanIntegrationSetup/>}/>
        <Route path={ROUTES_INTEGRATIONS_IDSCAN_LIST}
            element={<IdScanIntegrationList/>}/>
        <Route path={ROUTES_INTEGRATIONS_IDSCAN_DETAIL}
            element={<IdScanIntegrationDetail/>}/>

        <Route path={ROUTES_INTEGRATIONS}
            element={<IntegrationSetup subscriptions={subscriptions} subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}/>}/>
    </>

    const analyticsRoutes = <>
        <Route path={"/"} element={analyticsElement}/>
        {/*<Route path={ROUTES_ANALYTICS} element={analyticsElement}/>*/}
        <Route path={ROUTES_ANALYTICS_PRODUCT_DETAIL}
            element={<ProductDetail
                subscriptions={subscriptions}
                subscriptionItems={subscriptionItems}
                subscriptionProducts={subscriptionProducts}/>}/>
    </>

    return <>
        <MainMenu
            loggedInUser={loggedInUser}
            userProfile={userProfile}
            organizations={organizations}
            setHideCreatePaidAccount={(val) => {
                setCloseCreateAccountWorkflow(val);
                setShowCreateAccountWorkflow(!val)
            }}
            setLoggedInUser={setLoggedInUser}
            setUserProfile={setUserProfile}
        />
        <Routes>
            <Route path={"/welcome/"} element={<Home openCreateAccount={() => {
                setShowCreateAccountWorkflow(true);
                setCloseCreateAccountWorkflow(false);
            }}/>}/>
            <Route path={"/welcome"} element={<Home openCreateAccount={() => {
                setShowCreateAccountWorkflow(true);
                setCloseCreateAccountWorkflow(false);
            }}/>}/>
            {!loggedInUser?.id ? loggedOutRoutes : null}
            {loggedInUser?.id ? organizationRoutes : null}
            {loggedInUser?.id ? integrationRoutes : null}
            {loggedInUser?.id ? loggedInRoutes : null}
            {loggedInUser?.id ? analyticsRoutes : null}
        </Routes>
        {banner}
        {(!hasActiveSubscription || showCreateAccountWorkflow) && !closeCreateAccountWorkflow ?
            createPaidAccountJSX : null}
        {(!hasActiveSubscription || showCreateAccountWorkflow) && closeCreateAccountWorkflow ?
            <Banner variant="warning">
                <p>You don&apos;t have an active subscription!</p>
                <p>Click
                    <a
                        onClick={() => {
                            setShowCreateAccountWorkflow(true)
                            setCloseCreateAccountWorkflow(false);
                        }}
                        className="menubar menu-item">&nbsp;here&nbsp; </a>
                    to set one up.</p>
            </Banner> : null}
        {loggedInUser?.id && !(showCreateAccountWorkflow && !closeCreateAccountWorkflow) ? <IntegrationSelector loggedInUser={loggedInUser} organizations={organizations}
            subscriptions={subscriptions}/> : null}
        {isLoading ? <Loading/> : null}
    </>;
};


function App() {
    return (
        <Provider store={configureStore()}>
            <Router>
                <SnackbarProvider
                    anchorOrigin={{vertical: "top", horizontal: "center"}}
                    autoHideDuration={5000}
                >
                    <div className={"persistent-left-background"}></div>
                    <div className={"left-background"}></div>
                    <Main/>
                    <Popup/>
                    <Notifier/>
                </SnackbarProvider>
            </Router>
        </Provider>
    );
}

export default App;
